module.exports = __webpack_public_path__ + "img/alter_icon.64717417.svg";